<cc-box class="live-preview-box">
    <div
      box
      header>
      <div
        class="link"
        [ngClass]="{ active: state === 'SET_NOT_SUBMITTED'}"
        (click)="changeState('SET_NOT_SUBMITTED')">
        {{'LEAD_GENERATION.CREATOR.RADIO_POPUP' | translate}}
      </div>
      <div
        class="link"
        [ngClass]="{ active: state === 'SWITCH_TO_THANKS'}"
        (click)="changeState('SWITCH_TO_THANKS')">
        {{'LEAD_GENERATION.CREATOR.POPUP.THANK_YOU_PAGE' | translate}}
      </div>
    </div>
    <div
      class="box-content"
      box
      content>
      <div
        class="iframe-wrapper"
        [class.mobile]="!isDesktop">
        <iframe
          class="frame"
          [srcdoc]="previewHtml"
          id="widgetLive"></iframe>
      </div>
      <div
        class="box-actions"
        [class.mobile]="!isDesktop">
        <mat-icon
          [class.active]="isDesktop"
          (click)="handleChangeDevice(true)">desktop_windows
        </mat-icon>
        <mat-icon
          [class.active]="!isDesktop"
          (click)="handleChangeDevice(false)">stay_current_portrait
        </mat-icon>
      </div>
    </div>
  </cc-box>
